import React, { Component } from 'react';
import { UpdateTermsBackgroundImage } from './styledComponents';
import SUpdateTerms from 'shared/screens/UpdateTerms';
import StarTCs from '../../../components/TermsAndConditions/TCStar';

export default class StarUpdateTerms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oauthLoading: false,
      statusMessage: null,
      emailPermissionAccepted: null,
    };
  }

  render() {
    return (
      <SUpdateTerms
        navigation={this.props.navigation}
        {...this.props}
        render={args => {
          const { setTerms, terms, onSubmit, termsAndConditionsUrl, privacyPolicyUrl, checkSelectedTerms } = args;
          return (
            <>
              <UpdateTermsBackgroundImage alt="background" src={require(asset`images/Start/Splash_BG@3x.jpg`)} />
              <StarTCs
                isVisible={true}
                setTerms={setTerms}
                closeModal={() => checkSelectedTerms()}
                terms={terms}
                onSubmit={onSubmit}
                termsAndConditionsUrl={this.props.termsAndConditionsUrl || termsAndConditionsUrl}
                privacyPolicyUrl={this.props.privacyPolicyUrl || privacyPolicyUrl}
                test={this.props.poo}
              />
            </>
          );
        }}
      />
    );
  }
}
